export default {
    leaveType: 'ประเภทการลา',
    gender: 'เพศ',
    numberOfDays: 'จำนวนวัน',
    resetDay: 'รีเซตวัน',
    resetMonth: 'รีเซตเดือน',
    employment: 'ประเภทพนักงาน',
    searchLeaveTypes: 'ค้นหาประเภทการลา',
    search: 'ค้นหา',
    fullTimeLeave: 'พนักงานประจำ',
    personalLeave: 'ลากิจ',
    sickLeave: 'ลาป่วย',
    annualResetDate: 'รีเซ็ทประจำปี',
    saveChanges: 'บันทึก',
    probation: 'พนักงานทดลองงาน',
    probationLeave: 'พนักงานทดลองงาน',
    congratulation: 'ยินดีด้วย',
    action: 'แก้ไข',
    createLeaveType: 'สร้างประเภทการลา',
    deleteLeaveType: 'ลบประเภทการลา',
    wantToDelete: 'คุณเเน่ใจว่าต้องการที่จะลบประเภทการลา',
    leaveTypeIsDeleted: 'ประเภทการลาถูกลบแล้ว'
}
